import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const StyledStack = styled(Stack)({
  gap: '5px',
  span: {
    transform: 'none'
  }
});



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpTableSkeleton/styles.js